export function capitalizeFirstLetter(string) {
    if (!string) return '';

    return string.split(' ') // Split into words
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(' '); // Join back into a sentence
}